import styled from "styled-components";

import { Button as StyledButton } from "components/atoms/Button";
import { colourScheme } from "utils/styling/colours";

export const StatsContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    width: 100%;
    padding: 0.5rem;
    background: none;
    border-radius: 0.5rem;
    justify-content: flex-start;
    align-items: center;
`;

export const HeaderContainer = styled.div`
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    flex-direction: row;
    width: auto;
    gap: 1.5rem;
    text-align: center;
    position: relative;
`;

export const StatsContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const StatItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    background: ${colourScheme.primary};
    border-radius: 0.25rem;
    box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2);
`;

export const StatLabel = styled.span`
    font-weight: bold;
    color: ${colourScheme.secondaryLight};
`;

export const StatValue = styled.span`
    color: ${colourScheme.greyLight};
`;

export const Button = styled(StyledButton)`
    border: none;
    border-radius: 0.5;
    padding: 0.625rem 1rem;
    cursor: pointer;
`;

export const ContentContainer = styled.div`
    position: relative;
    padding: 0.75rem;
    background: ${colourScheme.primary};
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.3);
    margin-top: 0.75rem;
`;

export const RemoveButton = styled.button`
    position: relative;
    background: none;
    color: ${colourScheme.error};
    border: none;
    padding: 0.5rem;
    font-size: 1.5rem;
    cursor: pointer;
    z-index: 10;
`;

export const InfoText = styled.p`
    color: ${colourScheme.secondaryLight};
    margin: 0.5rem 0;
    text-align: center;
`;
